'use client';

import { c as _c } from "react/compiler-runtime";
import type { DocumentoPadrao } from '@/features/documentosPadrao/types/documentosPadraoTypes';
import { DOCUMENTO_PADRAO_TIPO_LABEL } from '@/features/documentosPadrao/utils/documentosPadraoRegras';
import { Button } from '@/shared/components/ui/common/Button';
import { Table } from '@/shared/components/ui/common/Table';
import { formatDateEuropean } from '@/shared/formatters';
import { FeatherArchive, FeatherRotateCcw, FeatherTrash2 } from '@subframe/core';
const CLASSE_CELULA = 'min-h-[72px] py-4';
interface DocumentosPadraoArquivadosTabelaProps {
  itens: DocumentoPadrao[];
  onVerDetalhes: (documento: DocumentoPadrao) => void;
  onRestaurar: (documento: DocumentoPadrao) => void;
  onExcluir: (documento: DocumentoPadrao) => void;
}
export function DocumentosPadraoArquivadosTabela(t0) {
  const $ = _c(12);
  const {
    itens,
    onVerDetalhes,
    onRestaurar,
    onExcluir
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Table.HeaderRow><Table.HeaderCell className="w-[44%]">Documento</Table.HeaderCell><Table.HeaderCell className="w-[26%]">Arquivado em</Table.HeaderCell><Table.HeaderCell className="w-[30%]"> </Table.HeaderCell></Table.HeaderRow>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== itens || $[2] !== onExcluir || $[3] !== onRestaurar || $[4] !== onVerDetalhes) {
    let t3;
    if ($[6] !== onExcluir || $[7] !== onRestaurar || $[8] !== onVerDetalhes) {
      t3 = documento => <Table.Row key={documento.id} clickable={true} className="cursor-pointer" onClick={() => onVerDetalhes(documento)}><Table.Cell className={CLASSE_CELULA}><div className="flex min-w-0 items-center gap-3"><div className="text-subtext-color flex h-9 w-9 flex-none items-center justify-center rounded-[8px] bg-neutral-100"><FeatherArchive className="h-[18px] w-[18px]" /></div><div className="min-w-0"><p className="text-body-bold font-body-bold text-subtext-color truncate">{documento.nome}</p><p className="text-caption font-caption truncate text-neutral-400">{`${DOCUMENTO_PADRAO_TIPO_LABEL[documento.tipo]} · ${documento.arquivo.nomeArquivo}`}</p></div></div></Table.Cell><Table.Cell className={CLASSE_CELULA}><span className="text-body font-body text-subtext-color">{`${formatDateEuropean(documento.arquivadoEm)} · ${documento.arquivadoPor ?? "\u2014"}`}</span></Table.Cell><Table.Cell className={`justify-end gap-2 ${CLASSE_CELULA}`} onClick={_temp}><Button variant="neutral-secondary" size="small" icon={<FeatherRotateCcw />} onClick={() => onRestaurar(documento)}>Restaurar</Button><Button variant="destructive-tertiary" size="small" icon={<FeatherTrash2 />} onClick={() => onExcluir(documento)}>Excluir</Button></Table.Cell></Table.Row>;
      $[6] = onExcluir;
      $[7] = onRestaurar;
      $[8] = onVerDetalhes;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = itens.map(t3);
    $[1] = itens;
    $[2] = onExcluir;
    $[3] = onRestaurar;
    $[4] = onVerDetalhes;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <div className="w-full overflow-x-auto"><Table className="table-fixed" header={t1}>{t2}</Table></div>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
function _temp(evento) {
  return evento.stopPropagation();
}